<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { appSectionsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import AppSectionsCreateForm from "@views/roles_management/app-sections/create-form";
import AppSectionsUpdateForm from "@views/roles_management/app-sections/update-form";

export default {
  page: {
    title: 'App sections',
    meta: [{ name: 'App sections management', content: 'App sections management' }],
  },
  components: { Layout, PageHeader, BaseDatatable,
    AppSectionsCreateForm, AppSectionsUpdateForm  },
  data() {
    return {
      title: this.$t('sections'),
      items: [
        {
          text: this.$t('home'),
          href: '/',
        },
        {
          text: this.$t('management'),
        },
        {
          text: this.$t('sections'),
          active: true,
        },
      ],
      tableHeaders: [
        {
          key: 'name',
          label:  this.$t('name'),
          sortable: true,
        },
        {
          key:  'path',
          label:  this.$t('path'),
          sortable: true,
        },
        {
          key: 'app_permission',
          label: this.$t('permission_required'),
          sortable: true,
        },
        {
          key: 'admin_required',
          label: this.$t('admin_required'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('actions'),
          sortable: true,
        },
      ],
      action : '',
      createForm: {
          name: '',
          path: '',
          hover_text: '',
          icon_name: '',
          admin_required : false,
          app_permission: false,
          parent: ''
      },
      updateForm: {
          url: '',
          name: '',
          path: null,
          hover_text: '',
          icon_name: '',
          admin_required : false,
          app_permission: false,
          parent: null
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
        content: ''
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false
    }
  },
  validations: {
    createForm: {
      name: {
        required,
        minLength: minLength(4)
      },
      path: {},
      hover_text: {},
      icon_name: {},
      admin_required : {},
      app_permission: {},
      parent: {},
    },
    updateForm: {
      name: {
        required,
        minLength: minLength(4)
      },
      path: {},
      hover_text: {},
      icon_name: {},
      admin_required : {},
      app_permission: {},
      parent: {},
    },
  },
  methods: {
    ...appSectionsMethods,

    myProvider(ctx) {
      const promise = this.fetchAppSections(this.$table_params(ctx))
      return promise.then(data => {
        return data
      }).catch(error => {
      this.$axios_error_noty(error, this)
      return []
      })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Section: ${item.name}`
      const promise = context.fetchAppSectionsDetail(item.url)
      return promise.then(data => {
        context.detailModal.content = data
        context.detailModal.class = data.icon_name || ""
        context.detailModalShow = !context.detailModalShow
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create'){
        this.createForm.name = ''
        this.createForm.path = null
        this.createForm.hover_text = ''
        this.createForm.icon_name = ''
        this.createForm.admin_required = false
        this.createForm.app_permission = false
        this.createForm.parent = null
        this.$v.createForm.$reset();
      }else{
        this.updateForm.url = ''
        this.updateForm.name = ''
        this.updateForm.path = null
        this.updateForm.hover_text = ''
        this.updateForm.icon_name = ''
        this.updateForm.admin_required = false
        this.updateForm.app_permission = false
        this.updateForm.parent = null
        this.$v.updateForm.$reset();
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create'){
        this.action = 'create'
        this.createUpdateModal.title = `Nueva Sección`
      }else{
        this.action = 'update'
        this.updateForm.url = item.url
        this.updateForm.name = item.name
        this.updateForm.path = item.path
        this.updateForm.hover_text = item.hover_text
        this.updateForm.icon_name = item.icon_name
        this.updateForm.admin_required = item.admin_required 
        this.updateForm.app_permission = !!item.app_permission
        this.updateForm.app_permission_detail = item.app_permission
        this.updateForm.parent = item.parent
        this.createUpdateModal.title = `Actualizar ${this.$t('section')}`
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      let context = this
      context.isSubmitting = true
      evt.preventDefault()
      if (context.$v.createForm.$anyError) {
        context.$v.createForm.$touch()
      }
      let form = context.action === 'create' ? context.createForm : context.updateForm
      const promise = context.createUpdateAppSections(form)
      return promise.then(data => {
        if (form.url){
          context.$generate_toast(context, 'success', 'Sección actualizada correctamente')
        }else{
          context.$generate_toast(context, 'success', 'Sección creada correctamente')
        }
        context.createUpdateModalShow = !context.createUpdateModalShow
        context.$refs.table.refresh()
        context.isSubmitting = false
        this.$store.dispatch('auth/validate', true)
        this.$store.dispatch('auth/setUserActiveSection', this.$route.path)
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },    
    deleteAppSection() {
      let context = this
      context.isSubmitting = true
      const promise = context.deleteAppSections(context.toDelete.url)
      return promise.then(data => {
        this.$store.dispatch('auth/validate', true)
        context.$generate_toast(context, 'success', 'Sección eliminada correctamente')
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
  }
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card >
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              >
              <template v-slot:buttons>
                <b-button
                    variant="outline-primary rounded-lg shadow-sm"
                    @click="openCreateUpdateModal(null, null, 'create')"
                    >
                    <i class="fas fa-plus"></i>
                </b-button>
              </template>
                <template v-slot:cell(name)="data">
                  <span v-for="(section, index) in data.item.parent_tree" :key="index">
                    <span v-if="index !== (data.item.parent_tree.length - 1)" style="color: #a9adb1;"> {{section.name}} > </span>
                    <span v-else> <b>{{ section.name }}</b> </span>
                  </span>
                </template>
                <template v-slot:cell(app_permission)="data">
                  <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                  <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
                </template>
                <template v-slot:cell(admin_required)="data">
                  <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                  <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
                </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="outline-info btn-transparent"
                    size="xs"
                    :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                    @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                    >
                    <i v-if="!actionsLoadings[`info-btn-${row.index}`]" class="fe-info fe-2x"></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                      >
                    </b-spinner>
                  </b-button>
                  <b-tooltip
                    :target="`info-btn-${row.index}`"
                    triggers="hover"
                    placement="bottomleft"
                    variant="info">
                    {{$t('detail')}}
                  </b-tooltip>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-warning btn-transparent"
                    size="xs"
                    @click="openCreateUpdateModal(row.item, row.index, 'update')"
                    >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`update-btn-${row.index}`"
                    triggers="hover"
                    placement="bottomleft"
                    variant="warning">
                    {{$t('edit')}}

                  </b-tooltip>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                    >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`delete-btn-${row.index}`"
                    triggers="hover"
                    placement="bottomleft"
                    variant="danger">
                    {{$t('delete')}}
                  </b-tooltip>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <b-modal 
      :id="detailModal.id"
      v-model="detailModalShow"
      ok-only
      :title="detailModal.title"
      @hide="resetdetailModal"
      >
      <!--{{ detailModal.content }}-->
      <table class="table-hover table-sm mb-0">
        <tr><th style="text-align:right">{{$t('name')}}</th><td>{{_.capitalize(detailModal.content.name)}}</td></tr>
        <tr><th style="text-align:right">{{$t('hover_text')}}</th><td>{{detailModal.content.hover_text }}</td></tr>
        <tr><th style="text-align:right">{{$t('icon')}}</th><td><i :class="detailModal.class"></i></td></tr>
        <tr><th style="text-align:right">¿ {{$t('admin_required')}}?</th><td>{{_.capitalize(detailModal.content.admin_required)}}</td></tr>
        <tr>
          <th style="text-align:right">¿{{$t('permission_required')}}?</th>
          <td v-if="detailModal.content.app_permission">
            <b>{{$t('name')}}: </b>{{ detailModal.content.app_permission.permission.name }} <br>
            <b>Codename: </b>{{ detailModal.content.app_permission.permission.codename }}
          <td v-else>
            False
          </td>
        </tr>
      </table>
      
    </b-modal>
        <!-- Create-Update modal -->
    <b-modal 
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'lg' : 'lg'"
      >
      <AppSectionsCreateForm 
        v-if="action === 'create'" 
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm">
      </AppSectionsCreateForm>
      <AppSectionsUpdateForm 
        v-if="action === 'update'" 
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm">
      </AppSectionsUpdateForm>
      
      <template v-slot:modal-footer>
          <b-button
            variant="outline-primary shadow rounded"
            class="float-right"
            @click="createUpdateModalShow = !createUpdateModalShow"
          >
            Cancel
          </b-button>
        <b-button
          type="submit"
          form="form"
          variant="primary shadow rounded"
          :disabled="action === 'create' ? $v.createForm.$invalid || isSubmitting : $v.updateForm.$invalid || isSubmitting"
        >
          <span
            v-if="!isSubmitting"
            >
            {{ $t('submit') }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Eliminar Sección"
      ok-title="Eliminar"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteAppSection"
      >
      <p>
        {{$t('are_sure_delete')}} la {{$t('section')}} {{$t('named')}} {{ toDelete ? toDelete.name  : '' }} ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-primary shadow rounded" @click="cancel">
          Cancelar
        </b-button>
        <b-button
          variant="danger shadow rounded"
          :disabled="isSubmitting"
          @click="ok">
          <span
            v-if="!isSubmitting"
            >
            {{ $t('delete') }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
